// extracted by mini-css-extract-plugin
export default {"title":"ActionPage_title__oAh3a","subtitle":"ActionPage_subtitle__leH0a","closeButton":"ActionPage_closeButton__ZEMwv"};